import { PropsWithChildren, ReactNode } from "react";
import { useUserContext } from "../../hooks/use-auth-context";
import { UserRoles } from "../../hooks/use-auth-context/types";
import { useCapabilities, CapabilityRequirement } from "../../hooks/use-capabilities";

type Props = PropsWithChildren<{
  roles?: UserRoles[];
  /** Capability slug(s) required to render children. */
  caps?: CapabilityRequirement;
  /** When true, require ALL caps; default is ANY. */
  requireAll?: boolean;
  /** Rendered when access is denied. Defaults to null (silent hide). */
  fallback?: ReactNode;
}>;

export const UserPermissionGate = ({
  children,
  roles,
  caps,
  requireAll = false,
  fallback = null,
}: Props) => {
  const { user } = useUserContext();
  const { hasAll, hasAny } = useCapabilities();

  const roleAllowed =
    !roles || roles.length === 0
      ? true
      : !!user?.role && roles.includes(user.role as UserRoles);

  const capAllowed =
    caps === undefined
      ? true
      : requireAll
      ? hasAll(caps)
      : hasAny(caps);

  if (!roleAllowed || !capAllowed) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
